import type { PaymentCompletedData, PaymentFailedData } from '@adyen/adyen-web';

import LinkButton from '@sats-group/fresh-fitness-ui-lib/react/link-button';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import React, { useRef, useState } from 'react';

import useAdyenDropin from 'root/client/components/adyen-dropin/adyen-dropin';
import ContentContainer from 'root/client/components/content-container/content-container';
import PaymentSummary from 'root/client/components/payment-summary/payment-summary';

import Banner from '../../components/banner/banner';
import SalesLayout from '../../components/sales-layout/sales-layout';

import type { DropInPayment as Props } from './drop-in-payment.types';

const DropInPayment: React.FC<Props> = ({
  actions,
  layout,
  messages,
  payment,
  paymentSummary,
  paymentMethodTitle,
}) => {
  const [localMessages, setLocalMessages] = useState<
    Parameters<typeof Banner>[0][]
  >([]);

  const dropinRef = useRef<HTMLDivElement>(null);

  const config = {
    clientKey: payment.clientKey,
    environment: payment.environment,
    locale: 'no',
    session: payment.session,
    onPaymentCompleted: (data: PaymentCompletedData) => {
      setLocalMessages([messages.paymentComplete[data.resultCode]]);

      window.location.assign(payment.nextHref);
    },
    onPaymentFailed: (data: PaymentFailedData) => {
      setLocalMessages([messages.paymentComplete[data.resultCode]]);
    },
  };

  useAdyenDropin({
    dropinRef,
    config,
    supportGooglePay: true,
  });

  return (
    <SalesLayout {...layout}>
      <ContentContainer width={ContentContainer.widths.Wide}>
        <div className="drop-in-payment">
          <noscript>
            <Banner {...messages.noscript} />
          </noscript>
          <div className="drop-in-payment__messages">
            {localMessages.map(entry => (
              <div key={entry.text}>
                <Banner {...entry} />
              </div>
            ))}
          </div>
          <div className="drop-in-payment__content">
            {paymentSummary ? <PaymentSummary {...paymentSummary} /> : null}
            <div className="drop-in-payment__payment">
              <Text
                elementName="h2"
                theme={Text.themes.emphasis}
                size={Text.sizes.large}
              >
                {paymentMethodTitle}
              </Text>
              {payment.session ? <div ref={dropinRef} /> : null}
              {actions.length ? (
                <div className="drop-in-payment__actions">
                  {actions.map(entry => (
                    <div key={entry.href}>
                      <LinkButton
                        {...entry}
                        theme={LinkButton.themes.secondary}
                        wide
                      />
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </ContentContainer>
    </SalesLayout>
  );
};

export default DropInPayment;
